import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import type { Field } from '@modules/dynamic-form-builder/model/formBuilderInterface';
import { Fields, validationMessage } from '@constants/constant';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-validation-errors',
  templateUrl: './validation-errors.component.html',
  styleUrls: ['./validation-errors.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ValidationErrorsComponent {
  @Input() control: FormControl;
  @Input() field: Field;

  get errorMessages() {
    if (this.control?.errors) {
      if (this.control.errors.required) {
        return [this.getErrorMessage('required')];
      } else {
        return Object.keys(this.control.errors).map((key) =>
          this.getErrorMessage(key)
        );
      }
    }
    return [];
  }

  private getErrorMessage(errorKey: string): string {
    if (this.field.validation?.validatorFunctions) {
      const fnObj = this.field.validation.validatorFunctions.find(fnObj => fnObj.errorKey === errorKey);
      if (fnObj && fnObj.message) {
        return `* ${fnObj.message}`;
      }
    }

    if (this.field.validation?.[errorKey]?.message) {
      return `* ${this.field.validation[errorKey].message}`;
    }

    if (validationMessage[errorKey]) {
      return `* ${validationMessage[errorKey].replace('<field>', this.field.label || Fields.FIELD)}`;
    }

    return `* Invalid Input`;
  }
}
